import {ModelBase} from "../../../../models/model-base";
import {Injectable} from "@angular/core";
import {CombinedOrderElementDto} from "../../time-performance-analysis-module/models/core/combined-order-element-dto";
import {SalesDto} from "../../single-event-analysis/models/sales/sales-dto";
import {AnalyticsBaseOrderDto} from "../models/core/analytics-base-order-dto";


// Todo: implement correctly and make generic
@Injectable({
  providedIn: 'root'
})
export class LinkedDtoRepository<E> {
  translationKey: {
    [K in keyof SalesDto | keyof AnalyticsBaseOrderDto | keyof CombinedOrderElementDto]: {
      [id: string]: ModelBase
    }
  } = {
    orderCount: {}, bookingType: {}, revenue: {}, eventId: {}, interval: {},
    id: {},
    locationId: {},
    timeInterval: {},
    compositionTypeId: {},
    orderId: {},
    pricePerUnit: {},
    quantity: {},
    compositionId: {},
    compositionCompositeId: {},
    // #534: the "one row per composition + swap combination" mapping, keyed by `SalesDto.compositionVariantKey`
    // and holding the variant LABEL (article name + its modification lines) as its `name`.
    compositionVariantKey: {},
    compositionName: {},
    modificationLines: {},
    hasSpecialTag: {},
    isActive: {},
    sourceDetailsCost: {},
    revenueAfterTax: {}
  };


  setDtoData<T extends keyof SalesDto | keyof AnalyticsBaseOrderDto | keyof CombinedOrderElementDto>(property: T, data: ModelBase[]) {
    this.translationKey[property] = data.reduce((acc, cur) => {
      acc[cur.id] = cur;
      return acc;
    }, {} as { [id: string]: ModelBase });
  }

  setDtoDataFromDictionary<T extends keyof SalesDto | keyof AnalyticsBaseOrderDto | keyof CombinedOrderElementDto>(property: T, data: {
    [id: string]: ModelBase
  }) {
    this.translationKey[property] = data;
  }

  public getMapping<T extends keyof SalesDto | keyof AnalyticsBaseOrderDto | keyof CombinedOrderElementDto>(property: T): {
    [id: string]: ModelBase
  } {
    return this.translationKey[property];
  }

  public getName<T extends keyof SalesDto | keyof AnalyticsBaseOrderDto | keyof CombinedOrderElementDto>(id: string, property: T, fallbackName: string = ""): string {
    let modelBase: ModelBase = this.translationKey[property][id];
    if (modelBase) {
      return modelBase.name;
    }
    return fallbackName;
  }

  public getKeyList<T extends keyof SalesDto | keyof AnalyticsBaseOrderDto | keyof CombinedOrderElementDto>(property: T): ModelBase[] {
    return Object.values(this.translationKey[property]) ?? [];
  }

  public getValueList<T extends keyof SalesDto | keyof AnalyticsBaseOrderDto | keyof CombinedOrderElementDto>(property: T): ModelBase[] {
    return Object.values(this.translationKey[property]) ?? [];
  }

  public getTranslationMapIdToName<T extends keyof SalesDto | keyof AnalyticsBaseOrderDto | keyof CombinedOrderElementDto>(property: T): {
    [id: string]: string
  } {
    let map: { [id: string]: string } = {};
    for (let id in this.translationKey[property]) {
      map[id] = this.translationKey[property][id].name;
    }
    return map;
  }

}
